import PropTypes from "prop-types";

export const ImagePropType = {
  url: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  caption: PropTypes.string,
};
